import React, { useState, useEffect } from "react";
import HomeHeader from "./HomeHeader";
import Footer from "./Footer";
import StaffPage from "./StaffPage";
import "./Styles/home.css";

const Home = () => {


  return (
    <div>
      <div className="headerderty">
        <HomeHeader />
      </div>

      <div>
       <StaffPage />
      </div>



      <Footer />
    </div>
  );
};

export default Home;
